module.exports = __webpack_public_path__ + "media/images/fig_skillup-f5a8b75eafc437918a9621b36273cfde.png";